import React, { useEffect, useState } from "react";
import { Card, Form, Button } from "react-bootstrap";
import EditHeader from "components/PantallasEdit/Header/EditHeader";
import SectionRow from "components/PantallasEdit/SectionRow/SectionRow";
import EditContainer from "components/PantallasEdit/EditContainer/EditContainer";
import InputContainer from "components/PantallasEdit/InputContainer/InputContainer";
import { ProcesoManager } from "managers";
import useMessage from "hooks/useMessage";
import useExceptionHandler from "hooks/useExceptionHandler";
import Select from "react-select";

export default function ProcesoEdit({ showLoading, hideLoading }) {
  const [proceso, setProceso] = useState({});
  const [procesosList, setProcesosList] = useState([]);

  const { Message, cerrarAlertas } = useMessage();
  const { handleException } = useExceptionHandler();


  useEffect(() => {
    cargarProceso();
    hideLoading();
    cerrarAlertas();
    return () => { };
  }, []);

  const cargarProceso = () => {
    showLoading();
    ProcesoManager.procesoAutomaticos().then((data) => {
      if (data && data.Success) {
        // Crear opciones combinando DescripcionProceso y TipoProceso
        const procesosOptions = data.Data.map(item => ({
          value: {
            DescripcionProceso: item.DescripcionProceso,
            TipoProceso: item.TipoProceso
          },
          label: item.DescripcionProceso
        }));
        setProcesosList(procesosOptions);

        if (data.Data.length > 0) {
          setProceso({
            DescripcionProceso: data.Data[0].DescripcionProceso,
            TipoProceso: data.Data[0].TipoProceso,
          });
        }
      } else {
        Message({ message: "No se pudieron cargar los procesos", type: "error" });
      }
    })
      .catch((e) => handleException(e))
      .finally(() => hideLoading());
  };

  const handleSelectChange = (selectedOption, actionMeta) => {
    const { name } = actionMeta;
    if (selectedOption) {
      setProceso(prev => ({
        ...prev,
        DescripcionProceso: selectedOption.value.DescripcionProceso,
        TipoProceso: selectedOption.value.TipoProceso
      }));
    } else {
      setProceso(prev => ({
        ...prev,
        DescripcionProceso: "",
        TipoProceso: ""
      }));
    }
  };

  const ejecutarProceso = () => {
    showLoading();
    ProcesoManager.ejecutarProceso(proceso).then(() => {
       Message({ message: `Proceso Ejecutado Exitosamente` });
    }).catch((e) => handleException(e))
      .finally(() => hideLoading());
  };

  return (
    <>
      <Form action="" className="form-horizontal" method="">
        <Card>
          <EditHeader
            titulo='Proceso'
            volver={true}
          />
          <EditContainer>
            <SectionRow>
              <InputContainer>
                <Form.Group>
                  <Form.Label>Proceso</Form.Label>
                  <Select
                    name="proceso"
                    value={procesosList.find(option => 
                      option.value.DescripcionProceso === proceso.DescripcionProceso && 
                      option.value.TipoProceso === proceso.TipoProceso
                    )}
                    onChange={handleSelectChange}
                    options={procesosList}
                    placeholder="Seleccione un proceso..."
                    isClearable
                    isSearchable
                  />
                </Form.Group>
              </InputContainer>
            </SectionRow>
            <SectionRow>
              <InputContainer>
                <Form.Group>
                  <Button 
                    variant="primary" 
                    onClick={ejecutarProceso}
                    disabled={!proceso.DescripcionProceso || !proceso.TipoProceso}
                  >
                    Ejecutar Proceso
                  </Button>
                </Form.Group>
              </InputContainer>
            </SectionRow>
          </EditContainer>
        </Card>
      </Form>
    </>
  );
}


